import React from 'react';
import classNames from 'classnames';
import styles from './CLFormErrorIndicator.module.scss';

export interface CLFormErrorIndicatorProps {
  validationError: string;
  validationErrorClassName?: string;
}

export default function CLFormErrorIndicator({
  validationError,
  validationErrorClassName,
}: CLFormErrorIndicatorProps) {
  return (
    <span className={classNames(styles.error_message, validationErrorClassName)}>
      {validationError}
    </span>
  );
}
